import Vue from 'vue'
import Router from 'vue-router'
// import HelloWorld from '@/components/layout/HelloWorld'

import Artworks from '@/components/artworks/Artworks'
import EditArtwork from '@/components/artworks/EditArtwork'
import ViewArtwork from '@/components/artworks/ViewArtwork'
import AddArtwork from '@/components/artworks/AddArtwork'

import LocationOverview from '@/components/artworks/LocationOverview'

import Artists from '@/components/artists/Artists'
import EditArtist from '@/components/artists/EditArtist'
import ViewArtist from '@/components/artists/ViewArtist'
import AddArtist from '@/components/artists/AddArtist'

import Locations from '@/components/locations/Locations'
import AddLocation from '@/components/locations/AddLocation'
import EditLocation from '@/components/locations/EditLocation'
// import ViewLocation from '@/components/locations/ViewLocation'

import Contacts from '@/components/contacts/Contacts'
import EditContact from '@/components/contacts/EditContact'
import ViewContact from '@/components/contacts/ViewContact'
import AddContact from '@/components/contacts/AddContact'

import Login from '@/components/login'
// import Login from '@/components/users/Login'
import Logout from '@/components/users/Logout'
import ForgottenPassword from '@/components/users/ForgottenPassword'
// import Settings from '@/components/users/Settings'
import Notifications from '@/components/users/Notifications'
import SettingsHome from '@/components/users/SettingsHome'
import Lists from '@/components/lists/Lists'
import Users from '@/components/users/Users'
import EditUser from '@/components/users/EditUser'

import Tags from '@/components/tags/Tags'
import AddNew from '@/components/tags/AddNew'

import Dashboard from '@/components/layout/Dashboard'
import Wizzard from '@/components/reports/Wizzard'
import Facts from '@/components/layout/Facts'

import Articles from '@/components/support/Articles'
import EditArticle from '@/components/support/EditArticle'
import AddArticle from '@/components/support/AddArticle'
import PublicArticles from '@/components/public/PublicArticles'
import PublicSettings from '@/components/public/PublicSettings'
import ArtworkSeries from '@/components/series/ArtworkSeries'

import SelectionIndex from '@/components/selections/Index'
import NetxSync from '@/components/selections/NetxSync'
import SelectionDetail from '@/components/selections/Detail'

import TodoIndex from '@/components/todos/Index'
import AddTodo from '@/components/todos/AddTodo'

import ExhibitionIndex from '@/components/exhibitions/Index'
import AddExhibition from '@/components/exhibitions/AddExhibition'
import EditExhibition from '@/components/exhibitions/EditExhibition'

import Texts from '@/components/texts/Index'
import AddText from '@/components/texts/AddText'
import EditText from '@/components/texts/EditText'

import store from '../store'

Vue.use(Router)

// const isNotAuthenticated = (to, from, next) => {
//   if (!store.getters.isAuthenticated) {
//     next()
//     return
//   }
//   next('/')
// }

const ifNotAuthenticated = (to, from, next) => {
  if (!store.getters.isAuthenticated) {
    // console.log('store.getters.isAuthenticated')
    // console.log(store.getters.isAuthenticated)
    next()
    return
  }
  next('/')
}

const ifAuthenticated = (to, from, next) => {
  if (store.getters.isAuthenticated) {
    next()
    return
  }
  next('/login')
}

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Artworks',
      component: Artworks,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
      beforeEnter: ifNotAuthenticated
    },
    {
      path: '/logout',
      name: 'Logout',
      component: Logout
    },
    {
      path: '/dashboard',
      name: 'Dashboard',
      component: Dashboard,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/articles',
      name: 'Articles',
      component: Articles,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/public-articles',
      name: 'PublicArticles',
      component: PublicArticles,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/public-settings',
      name: 'PublicSettings',
      component: PublicSettings,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/artwork-series',
      name: 'ArtworkSeries',
      component: ArtworkSeries,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/articles/edit/:id',
      name: 'EditArticle',
      props: true,
      component: EditArticle,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/articles/new',
      name: 'AddArticle',
      component: AddArticle,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/artworks',
      name: 'Artworks',
      component: Artworks,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/location_overview',
      name: 'LocationOverview',
      component: LocationOverview,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/reports/new',
      name: 'Wizzard',
      component: Wizzard,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/users',
      name: 'Users',
      component: Users,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/users/edit/:id',
      name: 'EditUser',
      component: EditUser,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/artworks/ownership/:ownership',
      name: 'Collection',
      component: Artworks,
      beforeEnter: ifAuthenticated
    },
    // {
    //   path: '/artworks/ownership/commissions',
    //   name: 'Commissions',
    //   component: Artworks,
    //   beforeEnter: ifAuthenticated
    // },
    {
      path: '/artworks/filter/:work_type',
      name: 'Collection Filtered',
      component: Artworks,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/contacts/:contact_category',
      name: 'ContactCategories',
      component: Contacts,
      beforeEnter: ifAuthenticated
    },
    // {
    //   path: '/artworks/pacFvh',
    //   name: 'pac_fvh',
    //   component: Artworks
    // },
    // {
    //   path: '/artworks/pdcFvh',
    //   name: 'pdc_fvh',
    //   component: Artworks
    // },
    // {
    //   path: '/artworks/pacMr',
    //   name: 'pac_mr',
    //   component: Artworks
    // },
    // {
    //   path: '/artworks/oldMasters',
    //   name: 'oldMasters',
    //   component: Artworks
    // },
    // {
    //   path: '/artworks/deaccession',
    //   name: 'Deaccession',
    //   component: Artworks
    // },
    {
      path: '/contacts/edit/:id',
      name: 'EditContact',
      component: EditContact,
      props: true,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/contacts/view/:id',
      component: ViewContact,
      name: 'ViewContact',
      props: true,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/artworks/new',
      name: 'AddArtwork',
      component: AddArtwork,
      props: true,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/artists/new',
      name: 'AddArtist',
      component: AddArtist,
      props: true,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/artworks/edit/:id',
      name: 'EditArtwork',
      component: EditArtwork,
      props: true,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/artworks/view/:id',
      component: ViewArtwork,
      name: 'ViewArtwork',
      props: true,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/selections',
      name: 'SelectionIndex',
      component: SelectionIndex,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/selections/:id',
      name: 'SelectionDetail',
      component: SelectionDetail,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/todos',
      name: 'TodoIndex',
      component: TodoIndex,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/exhibitions',
      name: 'ExhibitionIndex',
      component: ExhibitionIndex,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/exhibitions/new',
      name: 'AddExhibition',
      component: AddExhibition,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/todos/new',
      name: 'AddTodo',
      component: AddTodo,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/exhibitions/edit/:id',
      name: 'EditExhibition',
      component: EditExhibition,
      beforeEnter: ifAuthenticated
    },

    {
      path: '/artists',
      name: 'Artists',
      component: Artists,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/artists/edit/:id',
      name: 'EditArtist',
      component: EditArtist,
      props: true,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/artists/view/:id',
      name: 'ViewArtist',
      component: ViewArtist,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/contacts',
      name: 'Contacts',
      component: Contacts,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/contacts/new',
      name: 'AddContact',
      component: AddContact,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/locations',
      name: 'Locations',
      component: Locations,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/locations/edit/:id',
      name: 'EditLocation',
      component: EditLocation,
      props: true,
      beforeEnter: ifAuthenticated
    },
    // {
    //   path: '/locations/:id',
    //   name: 'ViewLocation',
    //   component: ViewLocation,
    //   beforeEnter: ifAuthenticated
    // },
    {
      path: '/locations/new',
      name: 'AddLocation',
      component: AddLocation,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/texts',
      name: 'Texts',
      component: Texts,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/texts/edit/:id',
      name: 'EditText',
      component: EditText,
      props: true,
      beforeEnter: ifAuthenticated
    },
    // {
    //   path: '/locations/:id',
    //   name: 'ViewLocation',
    //   component: ViewLocation,
    //   beforeEnter: ifAuthenticated
    // },
    {
      path: '/texts/new',
      name: 'AddText',
      component: AddText,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/lists',
      props: true,
      name: 'Lists',
      component: Lists,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/selections/:id/netx-sync',
      name: 'NetxSelectionSync',
      component: NetxSync,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/tags',
      name: 'Tags',
      component: Tags,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/tags/new',
      name: 'AddNew',
      component: AddNew,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/facts',
      name: 'Facts',
      component: Facts,
      beforeEnter: ifAuthenticated
    },
    // {
    //   path: '/login',
    //   component: Login,
    //   beforeEnter: ifNotAuthenticated
    // },
    {
      path: '/users/lostPassword',
      component: ForgottenPassword,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/account_settings',
      name: 'Account Settings',
      component: EditUser,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/notification_settings',
      name: 'Notifications Settings',
      component: Notifications,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/home_page_settings',
      name: 'Home Page Settings',
      component: SettingsHome,
      beforeEnter: ifAuthenticated
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js